export enum ReportType {
	SSRS = 1,
	State = 2,
	HTML = 3,
	NewSSRS = 4,
	NewState = 5,
	NewHTML = 6,
	MyNHA = 7
}
